// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textfield/Primary.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextField } from '@sail/ui';
export const Primary = () => <TextField label="Business name" placeholder="Acme Inc…" onChange={e => {
  // eslint-disable-next-line no-console
  console.log(e.target.value);
}} />;